import { render, staticRenderFns } from "./Protokoll.vue?vue&type=template&id=10dea378&scoped=true&"
import script from "./Protokoll.vue?vue&type=script&lang=js&"
export * from "./Protokoll.vue?vue&type=script&lang=js&"
import style0 from "./Protokoll.vue?vue&type=style&index=0&id=10dea378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dea378",
  null
  
)

export default component.exports